import { send } from 'server';
import { getXML } from 'js/utils/fetch.util';

export const getJackpots = ({
    jackpotsCasinoUrl, jackpotsCasino, currency
}) => getXML(`${jackpotsCasinoUrl}?info=2&casino=${jackpotsCasino}&currency=${currency}`);

export const getBingoJackpots = ({ bingoRegion, casinoName }) =>
    send({
        ID: 81704,
        description: 'Get Bingo Jackpots',
        responses: [81705, 81706],
        casino: casinoName,
        region: bingoRegion,
        uniqueJackpots: true,
        version: '1.7'
    });
